import React from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import ActorView from './ActorView';
import NotFound from './components/NotFound';

import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';
import AdminLogin from './components/AdminLogin';

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/:actor" element={<ActorView isAdmin={false} />} />

        {/* 管理者ログイン */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* 管理者画面 */}
        <Route
          path="/admin/:actor"
          element={
            <ProtectedRoute>
              <ActorView isAdmin={true} />
            </ProtectedRoute>
          }
        />

        {/* どのパスにもマッチしない場合は NotFound */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
}
